import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { DataownerBasic, OrgUnitRole } from '@dap/memberadmin/types';

export interface MemberadminContextType {
  dataownersForUser: DataownerBasic[];
  brandRoles: OrgUnitRole[];
}

export const MemberadminContext = createContext<MemberadminContextType | null>(null);

export const MemberadminContextProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: MemberadminContextType;
}) => {
  return <MemberadminContext.Provider value={value}>{children}</MemberadminContext.Provider>;
};

export const useMemberadminContext = () => {
  const context = useContext(MemberadminContext);
  if (!context) {
    throw new Error('useMemberAdminContext must be used within a MemberAdminContextProvider');
  }
  return context;
};
